module.exports = __webpack_public_path__ + "img/img2.80519f68.png";